<section class="login equal-height">
    <div class="container">
        <div class="login-box">
            <div class="row">
                <div class="col-lg-7 d-flex align-item-center">
                    <div class="banner-img">
                        <img src="./assets/images/forgot-password-img.svg" alt="">
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="form-content">
                        <div  routerLink="" class="back-btn"><mat-icon>arrow_back</mat-icon>{{'GENERAL.Back' | translate}}</div>
                        <div class="logo">
                            <img src="./assets/images/legance-color.svg" routerLink="" alt="">
                        </div>
                      <form name="forgotPasswordForm" [formGroup]="forgotPasswordForm" novalidate (ngSubmit)="onSubmit()">
                            <div class="form-wrapper">
                                <div class="input-wrapper">
                                    <div class="form-title">
                                        <h3>{{'RESETPASSWORDFORM.ForgotPassword' | translate }}</h3>
                                        <p>{{'RESETPASSWORDFORM.forgot_Password_Info' | translate }}</p>
                                    </div>
                                    <div class="form-field m-0">
                                        <mat-form-field appearance="outline" class="element-full-width">
                                            <mat-label>{{'RESETPASSWORDFORM.EmailID' | translate}}</mat-label>
                                            <input formControlName="email" id="email"  matInput maxlength="50" name="email" type="email" (keydown)="space($event)">
                                            <mat-error *ngIf="forgotPasswordForm.controls.email.errors?.required">{{'RESETPASSWORDFORM.EmailIDRequired' | translate}}</mat-error>
                                            <mat-error *ngIf="forgotPasswordForm.controls.email.errors?.email">{{'RESETPASSWORDFORM.Email_Address_Valid' | translate}}</mat-error>
                                         </mat-form-field>
                                    </div>
                                </div>
                                <div class="form-btn">
                                    <button class="full-btn"  mat-button  type="submit">{{'GENERAL.Submit' | translate}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

